export default {
  emits: [
    'open-thought',
    'close-thought',
    'edit-thought',
    'create-thought',
    'set-map-center',
    'cancel-thought-form',
    'feedback-thought',
    'close-thought-jump-to-map',
  ],
};
